import { type PapiDeviation, PapiError } from '@wix/da-papi-types';
import { FormField } from './types';

export const getErrorDetail = (error: PapiError): string => {
  if (error.errorDetails && error.errorDetails.errorKey) {
    return error.errorDetails.errorKey;
  }
  if (error.error) {
    return error.error;
  }
  if (error.errorCode) {
    return `${error.errorCode}`;
  }
  return 'error';
};

export function getSourceUrlInputName(deviation: PapiDeviation) {
  return `${FormField.SourceUrl}_${deviation.deviationId}`;
}

export function getSourceFilesInputName(deviation: PapiDeviation) {
  return `${FormField.SourceFiles}_${deviation.deviationId}`;
}

export function getSourceFilesInputNameByDeviationId(
  deviationId: number
) {
  return `${FormField.SourceFiles}_${deviationId}`;
}
